import axios from '../helpers/axiosConfig';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const EditGrade = () => {
  const { id } = useParams();
  let navigate = useNavigate();

  const [grade, setGrade] = useState({
    grade: '',
    libelle: '',
    anneeretraite: '',
    observation: '',
    gradeair: '',
    grademer: '',
    libellegradeair: '',
    libellegrademer: '',
    ordre: '',
  });

  useEffect(() => {
    const fetchGrade = async () => {
      try {
        const response = await axios.get(`grade/byid/2/${id}`);
        setGrade(response.data);
      } catch (err) {
        toast.error(err.response.data.error);
      }
    };

    fetchGrade();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGrade((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`grade/${id}`, grade);

      toast.info('Mise à jour réussie');
      navigate('/grade'); // Redirige vers la liste des grades
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur lors de la mise à jour');
    }
    /*     try {
          const response = await fetch(`grade/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(grade),
          });
          toast.info('Mise à jour réussi');
    
          navigate('/grade'); // Redirige vers la liste des grades
        } catch (err) {
          toast.error(err.response.data.error);
        } */
  };

  return (
    <div className="container mt-5 pt-3">
      <h2>Modifier le grade</h2>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <div className="col">
              <label>Grade</label>
              <input className="form-control" type="text" name="grade" value={grade.name} onChange={handleChange} required />
            </div>
            <div className="col">
              <label>Libellé</label>
              <input className="form-control" type="text" name="libelle" value={grade.libelle} onChange={handleChange} />
            </div>
            <div className="col">
              <label>Année de Retraite</label>
              <input className="form-control" type="number" name="anneeretraite" value={grade.anneeretraite} onChange={handleChange} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div>
              <label>Grade Air</label>
              <input className="form-control" type="text" name="gradeair" value={grade.gradeair} onChange={handleChange} />
            </div>
            <div>
              <label>Grade Mer</label>
              <input className="form-control" type="text" name="grademer" value={grade.grademer} onChange={handleChange} />
            </div>
            <div>
              <label>Libellé Grade Air</label>
              <input className="form-control" type="text" name="libellegradeair" value={grade.libellegradeair} onChange={handleChange} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div>
              <label>Libellé Grade Mer</label>
              <input className="form-control" type="text" name="libellegrademer" value={grade.libellegrademer} onChange={handleChange} />
            </div>
            <div>
              <label>Ordre</label>
              <input className="form-control" type="number" name="ordre" value={grade.ordre} onChange={handleChange} required />
            </div>
            <div>
              <label>Observation</label>
              <textarea className="form-control" name="observation" value={grade.observation} onChange={handleChange} />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary">
          Enregistrer
        </button>
      </form>
    </div>
  );
};

export default EditGrade;
